import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Card, Row, Col } from 'react-bootstrap';
import MasterSidebar from '@rd-web-markets/shared/dist/util/MasterSidebar';
import { AddButton } from '@rd-web-markets/shared/dist/util/buttons';
import AddHowToItemForm from './AddHowToItemForm';
import howToItemService from '@rd-web-markets/shared/dist/services/how_to_item.service';
import { api } from '@rd-web-markets/shared/dist/services/service';
import HowToItemList from './HowToItemList';

const HowToTemplatePage = () => {
  const { t } = useTranslation();
  const user = useSelector((state) => state.auth.user);

  const [loading, setLoading] = useState(false);
  const [showForm, setShowForm] = useState(false);

  const {
    items,
    setItems,
    deleteItem,
    updateItem,
    reorderItems,
  } = howToItemService.useCrud(setLoading);

  const handleUpdateOrder = async (reorderedItems) => {
		await reorderItems(reorderedItems);
		setItems([...reorderedItems]);
  };

  const handleCreateItem = async (formData) => {
    setLoading(true);
    try {
      const newItem = await api.postFormData('/how_to_items', formData);
      setItems((prev) => [...prev, newItem]);
      setShowForm(false);
    } catch (error) {
      console.error('Failed to create item', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Row className='justify-content-center mx-0 mt-4'>
        <Col md={10}>
          <Card className="mt-3">
            <Card.Header>{t('how_to')}</Card.Header>
            <Card.Body>
              <div className="d-flex justify-content-start mb-3">
                <AddButton
                  variant="info"
                  disabled={loading}
                  onClick={() => setShowForm((prev) => !prev)}
                  text={showForm ? t('hide_form') : t('add_how_to_item')}
                />
              </div>

              {showForm && (
                <AddHowToItemForm onSubmit={handleCreateItem} loading={loading} />
              )}

              <Card>
                <HowToItemList
                  items={items}
                  onUpdate={updateItem}
                  onDelete={deleteItem}
                  onUpdateOrder={handleUpdateOrder}
                />
              </Card>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default HowToTemplatePage;
